import React from 'react';
import Tooltip from '../ui/Tooltip';
import ShortcutHint from '../ui/ShortcutHint';

/**
 * Icon button with the app's Tooltip (never a native `title`) naming the
 * action and, when given, its shortcut. A disabled button stays visible and
 * focusable (`aria-disabled`) and its tooltip says WHY it is disabled.
 */
export default function TermIconButton({
  label,
  keys,
  disabledReason,
  onClick,
  children,
  className = 'term-icon-btn',
  side = 'bottom',
  pressed,
  ...rest
}) {
  const disabled = !!disabledReason;
  const content = disabled ? (
    <span>
      {label} — {disabledReason}
    </span>
  ) : keys && keys.length ? (
    <ShortcutHint label={label} keys={keys} />
  ) : (
    label
  );
  return (
    <Tooltip content={content} side={side}>
      <button
        type="button"
        className={className}
        aria-label={disabled ? `${label} — ${disabledReason}` : label}
        aria-disabled={disabled ? 'true' : undefined}
        aria-pressed={pressed}
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) onClick?.(e);
        }}
        {...rest}
      >
        {children}
      </button>
    </Tooltip>
  );
}
